import React, { FC } from "react";
import { FieldArray } from "react-final-form-arrays";
import ProgramTypeInput from "../../../components/step1/ProgramTypeInput";
import ProgramDuration from "../../../components/step1/ProgramDuration";
import AssignBranches from "../../../components/step1/AssignBranches";
import { Intakes } from "../../../components/step1/Intakes";
import { IStepTemplate } from "../../../types";
import MajorSection from "../../../components/step1/MajorSection";

const Template: FC<IStepTemplate> = ({ stepName, formData }) => (
  <>
    <MajorSection name={stepName} />
    <ProgramTypeInput name={stepName} />
    <ProgramDuration name={stepName} />
    <Intakes stepName={stepName} />
    <FieldArray
      stepName={stepName}
      name={`${stepName}.branches`}
      component={AssignBranches}
    />
  </>
);

export default Template;
